export class DashboardModel {
  charts: Record<string, DashboardChartData> = {};
  overview: DashboardOverview = new DashboardOverview();
}

export class DashboardChartData {
  data: TextValuePair[] = [];
  hasLicense: boolean = false;
  optionalInfo?: TextValuePair[] = [];
}

class DashboardOverview {
  filters?: DashboardFilters = new DashboardFilters();
  labels: DashboardLabels = new DashboardLabels();
}

export class DashboardFilters {
  createTimeStart?: number;
  createTimeEnd?: number;
}

class DashboardLabels {
  total: string = "";
  totalUniqueCases: string = "";
  currency: string = "";
  currencySize: string = "";
}

class TextValuePair {
  text: string = "";
  value: string = "";
}
